module.exports = __webpack_public_path__ + "static/media/logo_inverted.795f6b0b.png";